import React, { useEffect, useState } from 'react';
import { PHSHeader } from '../../components/UI/header';
import DataTable from '../../components/UI/table';
import { styles } from './index.sass';
import { Button, Modal, Form, Input, InputNumber, DatePicker } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { CheckCircleTwoTone, ClockCircleTwoTone } from '@ant-design/icons';
import { SESSION_ALERT_EMAIL_TEMPLATE, SESSION_ALERT_EMAIL_TYPE } from '../../utils/constant';
import { createContractorSession, getContractorSessions } from '../../api/contractorSession';

export const ContractorSessions = () => {
    const [loading, setLoading] = useState(false);
    const [sessions, setSessions] = useState([]);
    const [selectedSession, setSelectedSession] = useState(null);
    const [emailContent, setEmailContent] = useState('');

    const columns = [
        {
            title: 'Status', key: 'is_approved', render: (record) => {
                const matched = record.appointment_id ? true : false;
                let is_partial_matched = false;
                if (matched) {
                    const original_appointment = JSON.parse(record.original_appointment);
                    console.log('original_appointment', original_appointment, record);
                    is_partial_matched = !(original_appointment.duration === record.duration && Number(original_appointment.session_count) === record.session_count && original_appointment.pay === record.pay);
                }
                return (
                    (record.appointment_id && !is_partial_matched) ?
                        <CheckCircleTwoTone twoToneColor="#52c41a" title="Matched" /> :
                        (is_partial_matched ? <ClockCircleTwoTone twoToneColor="#faad14" title="Partially Matched" /> : <ClockCircleTwoTone twoToneColor="red" title="Unmatched" />)
                )
            }
        },
        { title: 'Contractor Name', dataIndex: 'contractor_name', key: 'contractor_name' },
        { title: 'Person Id', dataIndex: 'client_id', key: 'client_id' },
        { title: 'Duration', dataIndex: 'duration', key: 'duration' },
        { title: 'Session Count', dataIndex: 'session_count', key: 'session_count' },
        { title: 'Date', dataIndex: 'date', key: 'date' },
        { title: 'Pay', dataIndex: 'pay', key: 'pay' },
        { title: 'Original Appointment', dataIndex: 'original_appointment', key: 'original_appointment' },
    ];

    const fetchContractorSessions = async () => {
        setLoading(true);
        const sessions = await getContractorSessions();
        setSessions(sessions);
        setLoading(false);
    }

    const onClickOpenEmailModal = (record) => {
        setEmailContent(SESSION_ALERT_EMAIL_TEMPLATE.replace('[Client Name]', record.name))
        setSelectedSession(record);
    }

    const onClickCreateContractorSession = async (data) => {
        setLoading(true);
        await createContractorSession(data);
        setLoading(false);
        setSelectedSession(null);
        fetchContractorSessions();
    }

    useEffect(() => {
        fetchContractorSessions();
    }, []);


    return (
        <div className={styles}>
            <PHSHeader
                hideBreadCrumb={true}
                hideSubHeader={true}
            />
            <div className='container'>
                <div className='flex'>
                    <h2>Contractor Sessions</h2>
                    <div>
                        <Button type="default" onClick={() => setSelectedSession({})}>
                            <PlusOutlined />
                        </Button>
                    </div>
                </div>
                <div>
                    <DataTable
                        columns={columns || []}
                        dataSource={sessions || []}
                        loading={loading}
                        hidePagination={true}
                    />
                </div>
                <Modal
                    open={selectedSession !== null}
                    onCancel={() => setSelectedSession(null)}
                    footer={null}
                >
                    <div>
                        <div style={{ fontWeight: 600, marginBottom: 12 }}>Create Contractor Session</div>
                        <Form
                            layout="vertical"
                            initialValues={{
                                contractor_name: selectedSession && selectedSession.contractor_name ? selectedSession.contractor_name : '',
                                client_id: selectedSession && selectedSession.client_id ? selectedSession.client_id : '',
                                duration: selectedSession && selectedSession.duration ? Number(selectedSession.duration) : '',
                                date: selectedSession && selectedSession.date ? selectedSession.date : null,
                                pay: selectedSession && selectedSession.pay ? Number(selectedSession.pay) : '',
                            }}
                            onFinish={(data) => onClickCreateContractorSession(data)}
                        >
                            <Form.Item label="Contractor Name" name="contractor_name" rules={[{ required: true, message: 'Please enter contractor name' }]}>
                                <Input
                                    value={selectedSession && selectedSession.contractor_name ? selectedSession.contractor_name : ''}
                                    onChange={e => setSelectedSession(Object.assign({}, selectedSession, { contractor_name: e.target.value }))}
                                />
                            </Form.Item>
                            <Form.Item label="Person Id" name="client_id" rules={[{ required: true, message: 'Please enter person id' }]}>
                                <Input
                                    value={selectedSession && selectedSession.client_id ? selectedSession.client_id : ''}
                                    onChange={e => setSelectedSession(Object.assign({}, selectedSession, { client_id: e.target.value }))}
                                />
                            </Form.Item>
                            <Form.Item label="Duration (minutes)" name="duration" rules={[{ required: true, message: 'Please enter duration' }]}>
                                <InputNumber
                                    style={{ width: '100%' }}
                                    value={selectedSession && selectedSession.duration ? Number(selectedSession.duration) : ''}
                                    onChange={value => setSelectedSession(Object.assign({}, selectedSession, { duration: value }))}
                                />
                            </Form.Item>
                            <Form.Item label="Date" name="date" rules={[{ required: true, message: 'Please select date' }]}>
                                <DatePicker
                                    style={{ width: '100%' }}
                                    value={selectedSession && selectedSession.date ? selectedSession.date : null}
                                    onChange={(_, dateString) => setSelectedSession(Object.assign({}, selectedSession, { date: dateString }))}
                                />
                            </Form.Item>
                            <Form.Item label="Pay ($)" name="pay" rules={[{ required: true, message: 'Please enter pay' }]}>
                                <InputNumber
                                    style={{ width: '100%' }}
                                    value={selectedSession && selectedSession.pay ? Number(selectedSession.pay) : ''}
                                    onChange={value => setSelectedSession(Object.assign({}, selectedSession, { pay: value }))}
                                />
                            </Form.Item>
                            <Form.Item>
                                <Button type="primary" htmlType="submit" loading={loading}>
                                    Submit
                                </Button>
                            </Form.Item>
                        </Form>
                    </div>
                </Modal>
            </div>
        </div >
    )
}